import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    listData: {
      type: Array
    },
    but: {
      type: Object
    },
    title: {
      type: String
    },
    authority: {
      type: Object
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    handleItem: function handleItem(item) {
      this.$emit('handleItem', item);
    },
    handleHistory: function handleHistory(item) {
      this.$router.push({
        path: item.path
      });
    },
    handleTiming: function handleTiming(item) {
      this.$router.push({
        path: item.path
      });
    }
  }
};